module.exports = __webpack_public_path__ + "static/media/82295346_960802537711665_5799112139239063552_n.0cd2362f.jpg";